import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PreOrderComponent } from '@pages/partbnb-component';

export const routes: Routes = [
  {
    path: ':id',
    component: PreOrderComponent,
    data: {
      moduleName: 'preorder',
      pageTitle: 'Partbnb - Pre-Order',
      pageName: 'Pre-Order'
    }
  },
  { path: '**', component: PreOrderComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PreOrderRoutingModule {}
